import {
  Autocomplete,
  AutocompleteChangeReason,
  createFilterOptions,
  TextField,
} from "@mui/material";
import { Fragment, useState } from "react";
import { Vocabulary } from "../../Utils/Vocabulary";
import { OrderModel, ProductsModel } from "../../Utils/Models";
import { Controller } from "react-hook-form";
import { EditProductProps } from "../../Utils/Types";
import styles from "../../Styles/products.module.css";

const filterOptions = createFilterOptions<ProductsModel>({
  matchFrom: "any",
  stringify: (option) => option?.name || "",
});

export const EditProduct = (props: EditProductProps) => {
  const [localError, setLocalError] = useState(false);

  const mapPropsForProduct = (product: any) => {
    const newProduct = Object.assign({}, new ProductsModel());
    newProduct.name = product?.name;
    return newProduct;
  };

  return (
    <Fragment>
      <Controller
        name={`product.name`}
        control={props.control}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <>
            <Autocomplete
              size="small"
              disableClearable
              id={`product.name`}
              disabled={props.disabled}
              fullWidth={true}
              className={styles.editProductOrderOffer}
              freeSolo={false}
              disablePortal
              filterOptions={filterOptions}
              isOptionEqualToValue={(option: any, value: any) => {
                return option?._id === value?._id && value?._id;
              }}
              getOptionLabel={(option: any) => option?.name || ""}
              options={props.products || []}
              value={props.getValues(`product`) || { name: null }}
              onChange={(
                e: any,
                product: OrderModel,
                reason: AutocompleteChangeReason,
                details?: any
              ) => {
                props.onProductChange(
                  e,
                  mapPropsForProduct(product),
                  reason,
                  details
                );
                setLocalError(true);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={styles.editProductOrderOffer}
                  InputProps={{
                    style: {
                      fontWeight: props.isOrderOffer ? "bold" : "normal",
                    },
                    ...params.InputProps,
                    rows: 4,
                    multiline: false,
                  }}
                  fullWidth={true}
                  name={`product.name`}
                  error={!localError && !!error}
                  helperText={!localError && error?.message}
                  label={Vocabulary.productName}
                  variant="standard"
                />
              )}
            />
          </>
        )}
      />
    </Fragment>
  );
};
